export default __webpack_public_path__ + "static/Rubik-Bold-6fb91b0d751523673343edcb8038a371.ttf";